export const breedSelectRef = document.querySelector('.breed-select');
export const catInfoRef = document.querySelector('.cat-info');
export const loaderRef = document.querySelector('.loader');
export const errorRef = document.querySelector('.error');